// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.ef-root {\n\t--ef-ink: #0E1B2E;\n\t--ef-slate: #5A6577;\n\t--ef-faint: #A9B0C4;\n\t--ef-line: #E2E6EC;\n\t--ef-band: #F3F5F8;\n\t--ef-blue: #2778DC;\n\t--ef-blue-deep: #1E62B8;\n\t--ef-mist: #E6F0FC;\n\t--ef-amber-soft: #FEF3DF;\n\t--ef-amber-ink: #8A5A05;\n\t--ef-danger: #D94C45;\n\t--ef-danger-soft: #FBE9E8;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
